import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import {
  Box,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  useTheme,
} from "@mui/material";
import PropTypes from "prop-types";
import { get, isBoolean } from "lodash";

import { confirmationOptions } from "common/constant";

const YesNoRadioButton = ({
  t,
  keyName,
  label,
  formik,
  isRequired,
  ...radioProps
}) => {
  const theme = useTheme();
  const { setFieldValue, touched, errors, values } = formik;

  const errorMessage = useMemo(
    () => get(errors, keyName, ""),
    [get(errors, keyName, "")]
  );

  const isError = useMemo(
    () => !!get(touched, keyName, "") && !!errorMessage,
    [get(touched, keyName, ""), errorMessage]
  );

  const value = useMemo(() => get(values, keyName), [get(values, keyName)]);

  return (
    <>
      <Grid item>
        <Typography sx={{ pt: 1 }}>
          {t(label)}
          {isRequired && <span className="text-danger">*</span>}
        </Typography>
      </Grid>
      <Grid item>
        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
          <Box>
            <RadioGroup
              row
              name={keyName}
              value={isBoolean(value) ? (value ? 1 : 0) : ""}
              onChange={(e) => {
                setFieldValue(keyName, !!+e.target.value);
              }}
              {...radioProps}
            >
              {confirmationOptions.map(({ label, value }, index) => (
                <FormControlLabel
                  key={index}
                  value={value}
                  control={<Radio />}
                  label={t(label)}
                />
              ))}
            </RadioGroup>
          </Box>
          {isError && (
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ color: theme.palette.error.main, pt: 1.2 }}
              >
                {t(errorMessage)}
              </Typography>
            </Box>
          )}
        </Box>
      </Grid>
    </>
  );
};

YesNoRadioButton.propTypes = {
  label: PropTypes.string,
  keyName: PropTypes.string,
  formik: PropTypes.object,
  t: PropTypes.func,
  isRequired: PropTypes.bool,
};

export default withTranslation()(YesNoRadioButton);
